<template>
	<div class="main-page">
		<!-- audio -->
		<audio id="timeLeftNocie" class="dn" ref="audioPlayer">
			<source src="../assets/image/little-bell-14606.mp3" type="audio/mpeg">
		</audio>
		<!-- loading -->
		<div id="loading" class="flex-rc-cc dn"><img src="../assets/image/loading.svg" alt="" /></div>
		<!-- alert -->
		<div id="calert" class="flex-rc-cc dn">
			<div class="calert-container">
				<h4 class="calert-title" style="text-align: center; padding: 20px 20px 0;font-size: 1.2em;"></h4>
				<div class="calert-text"> </div>
				<div class="calert-btn" @click="hide_calert">OK</div>
			</div>
		</div>
		<div v-if="info.status==0 || info.status==2"><FormClosed :title="closedTitle" :startStamp="info.startStamp" :description="description"/></div>
		<!-- page0 -->
		<div id="page-0" v-if="page == 0">
			<div class="page0-wrapper">
				<div class="page0-card shadow">
					<div class="page0-icon">
						<svg width="48" height="48" viewBox="0 0 24 24" fill="#673ab7"><path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2z"/></svg>
					</div>
					<h2 class="page0-card-title">Password Required</h2>
					<p class="page0-card-desc">Please enter the password to access this form</p>
					<div style="position: relative;">
						<input class="page0-card-input" type="text" placeholder="Enter password" v-model="password"
							autofocus @keyup.enter="password && getInfo()" autocomplete="off"
							:style="'padding-right: 40px;' + (showPwd ? '' : '-webkit-text-security: disc; text-security: disc;')" />
						<svg @click="showPwd = !showPwd" style="position:absolute;right:12px;top:50%;transform:translateY(-50%);cursor:pointer;width:20px;height:20px;" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="#999" stroke-width="2">
							<path v-if="showPwd" stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88" />
							<path v-else stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178zM15 12a3 3 0 11-6 0 3 3 0 016 0z" />
						</svg>
					</div>
					<div class="page0-card-btn" :class="!password ? 'disable' : ''" @click="password && getInfo()">Continue</div>
				</div>
				<div class="page-foot">
					<p>Made with <a href="https://formtimers.com" target="_blank">Timer for Google Forms</a></p>
				</div>
			</div>
		</div>

		<!-- page1 -->
		<div id="page-1" v-if="page == 1">

			<div class="page1 flex-column">
				<div class="flex-fill">
					<div class="page-box shadow">
						<div class="page-box-headLine bg-purple"></div>
						<div class="page-box-container">
							<div class="flex-rb">
								<div class="page1-box-title flex-fill">{{info.formName}}</div>
								<div class="page1-box-time">
									<p class="tr">time allowed</p>
									<p class="page1-box-time-num">{{getTimeText_type1(info.time)}}</p>
								</div>
								<svg class="page1-box-clock" focusable="false" viewBox="0 0 24 24" aria-hidden="true" style="font-size: 3.4em;"><path d="M15 1H9v2h6V1zm-4 13h2V8h-2v6zm8.03-6.61l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42C16.07 4.74 14.12 4 12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9 9-4.03 9-9c0-2.12-.74-4.07-1.97-5.61zM12 20c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"></path></svg>
							</div>
							<div class="page1-box-content">{{info.instruction}}</div>
						</div>
					</div>

					<div class="page-box shadow">
						<div class="page-box-headLine bg-purple"></div>
						<div class="page-box-container">
							<input class="page1-box-input" type="text" placeholder="your full name" v-model="name" />
						</div>
					</div>

					<div class="page-button shadow2" :class="!name ? 'disable' : ''" @click="submit">Start</div>

					<div class="page-tips">
						<p>This is a timed form, the time it takes you to complete it will be recorded. Make sure you
							submit on time !</p>
						<p>If you submit late, your response will still be saved.</p>
					</div>
				</div>

				<div class="page-foot">
					<p>Made with <a href="https://formtimers.com" target="_blank">Timer for Google Forms</a></p>
				</div>
			</div>
		</div>

		<div id="page-2" v-else-if="page == 2">
			<div class="cover" @click="cover_click" v-if="timeSelectShow == 1"></div>
			<div class="page2">
				<div class="page2-time-box flex-rb-cc" v-if="!info.timerOff">
					<div class="page2-time-num" v-if="showRecord == 0">{{getTimeText_type2(totalTime-spandTime)}}</div>
					<div class="page2-time-process flex-fill" v-if="showRecord == 0">
						<div class="page2-time-process-active" :style="'width:' + (1-spandTime/totalTime)*100 + '%;'">
						</div>
					</div>
					<div class="page2-time-num flex-fill nowrap" v-if="showRecord == 1">Time recorded:
						{{getTimeText_type3(spandTime)}}
						<span v-if="spandTime > totalTime" style="color: #f59e0b; margin-left: 4px;">(Late {{getTimeText_type3(spandTime - totalTime)}})</span></div>
					<div class="page2-time-finger flex-rc-cc">
						<svg style="width:1em;height:1em;margin-right:0.2em;" focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M17.81 4.47c-.08 0-.16-.02-.23-.06C15.66 3.42 14 3 12.01 3c-1.98 0-3.86.47-5.57 1.41-.24.13-.54.04-.68-.2-.13-.24-.04-.55.2-.68C7.82 2.52 9.86 2 12.01 2c2.13 0 3.99.47 6.03 1.52.25.13.34.43.21.67-.09.18-.26.28-.44.28zM3.5 9.72c-.1 0-.2-.03-.29-.09-.23-.16-.28-.47-.12-.7.99-1.4 2.25-2.5 3.75-3.27C9.98 4.04 14 4.03 17.15 5.65c1.5.77 2.76 1.86 3.75 3.25.16.22.11.54-.12.7-.23.16-.54.11-.7-.12-.9-1.26-2.04-2.25-3.39-2.94-2.87-1.47-6.54-1.47-9.4.01-1.36.7-2.5 1.7-3.4 2.96-.08.14-.23.21-.39.21zm6.25 12.07c-.13 0-.26-.05-.35-.15-.87-.87-1.34-1.43-2.01-2.64-.69-1.23-1.05-2.73-1.05-4.34 0-2.97 2.54-5.39 5.66-5.39s5.66 2.42 5.66 5.39c0 .28-.22.5-.5.5s-.5-.22-.5-.5c0-2.42-2.09-4.39-4.66-4.39-2.57 0-4.66 1.97-4.66 4.39 0 1.44.32 2.77.93 3.85.64 1.15 1.08 1.64 1.85 2.42.19.2.19.51 0 .71-.11.1-.24.15-.37.15zm7.17-1.85c-1.19 0-2.24-.3-3.1-.89-1.49-1.01-2.38-2.65-2.38-4.39 0-.28.22-.5.5-.5s.5.22.5.5c0 1.41.72 2.74 1.94 3.56.71.48 1.54.71 2.54.71.24 0 .64-.03 1.04-.1.27-.05.53.13.58.41.05.27-.13.53-.41.58-.57.11-1.07.12-1.21.12zM14.91 22c-.04 0-.09-.01-.13-.02-1.59-.44-2.63-1.03-3.72-2.1-1.4-1.39-2.17-3.24-2.17-5.22 0-1.62 1.38-2.94 3.08-2.94 1.7 0 3.08 1.32 3.08 2.94 0 1.07.93 1.94 2.08 1.94s2.08-.87 2.08-1.94c0-3.77-3.25-6.83-7.25-6.83-2.84 0-5.44 1.58-6.61 4.03-.39.81-.59 1.76-.59 2.8 0 .78.07 2.01.67 3.61.1.26-.03.55-.29.64-.26.1-.55-.04-.64-.29-.49-1.31-.73-2.61-.73-3.96 0-1.2.23-2.29.68-3.24 1.33-2.79 4.28-4.6 7.51-4.6 4.55 0 8.25 3.51 8.25 7.83 0 1.62-1.38 2.94-3.08 2.94s-3.08-1.32-3.08-2.94c0-1.07-.93-1.94-2.08-1.94s-2.08.87-2.08 1.94c0 1.71.66 3.31 1.87 4.51.95.94 1.86 1.46 3.27 1.85.27.07.42.35.35.61-.05.23-.26.38-.47.38z"></path></svg>
						<div class="page2-time-finger-name">{{info.fingerCode}}</div>
					</div>
					<div class="page2-time-clock" @click="showTimeSelect(timeSelectShow == 1 ? 0 : 1)">
						<svg style="width:1.5em;height:1.5em;fill:rgba(0, 0, 0, 0.54);display:block;" focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12.5 8H11v6l4.75 2.85.75-1.23-4-2.37V8zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"></path></svg>
					</div>

					<div class="page2-time-select-box shadow" v-if="timeSelectShow == 1">
						<div class="page2-time-select-head">
							<p class="page2-time-select-head-title">Alarms</p>
							<p class="page2-time-select-head-content">Tab must be focused</p>
						</div>
						<div class="page2-time-select-item flex-rb-cc" v-for="(item, index) in timeLeft_dis"
							:key="index" @click="toggleTimeLeft(index)">
							<div class="page2-time-select-item-text"
								:class="totalTime-spandTime < item.time ? 'disable' : ''">
								{{getTimeText_type1(item.time)}} left
							</div>
							<div class="page2-time-select-item-toggle">
								<img src="../assets/image/right-disable.png"
									v-if="item.isToggle && totalTime-spandTime < item.time" />
								<img src="../assets/image/right.png"
									v-if="item.isToggle && totalTime-spandTime >= item.time" />
								<img src="../assets/image/close.png" v-if="!item.isToggle" />
							</div>
						</div>
					</div>

				</div>

				<div class="page-container">
					<div class="ifame" :class="info.timerOff ? 'iframeFull' : ''">
						<iframe id="iframe" v-if="info.formId"
							:src="'https://docs.google.com/forms/d/' + info.formId + '/viewform?entry.' + info.entryId + '=' +info.fingerCode"
							width='100%' height='100%' frameborder='0' name="_blank"></iframe>
					</div>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
	import $ from 'jquery'
	import { formatTimestamp } from './ComFun'
	import FormClosed from './FormClosed.vue'


	export default {
		name: 'mainPage',
		props: {
			msg: String
		},
		components: {
          FormClosed
        },
		data: () => {
			return {
				serverType: window.location.hostname === 'localhost' ? 'dev' : 'pub',
				host: window.location.hostname === 'localhost' ? 'http://localhost:8787' : 'https://api.t.formtimers.com',

				shortId: null,
				page: -1,
				pageviewId: Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2),
				pageStartTime: Date.now(),
				visibleDuration: 0,
				lastVisibleTime: Date.now(),
				info: {},
				name: "",
				password: "",
				showPwd: false,

				totalTime: 0,
				spandTime: 0,
				showRecord: 0,
				Timer: null,
				successTimer: null,
				ws: null,
				wsHeartbeat: null,
				timeSelectShow: 0,
				timeLeft_dis: [{
						time: 120,
						isMention: false,
						isToggle: false,
					},
					{
						time: 300,
						isMention: false,
						isToggle: false,
					},
					{
						time: 900,
						isMention: false,
						isToggle: false,
					},
					{
						time: 1800,
						isMention: false,
						isToggle: false,
					},
					{
						time: 3600,
						isMention: false,
						isToggle: false,
					},
					{
						time: 7200,
						isMention: false,
						isToggle: false,
					},
				],
				hideTimeStamp: 0,
				hideSpandTime: 0,
				closedTitle: "Form Closed",
				description:"",
			}
		},
		mounted() {
			let that = this
			this.shortId = this.getShortId();

			if (this.serverType == 'dev') {
				// this.shortId = "AbCdEf"; // for test
			}

			this.getInfo();

			// 页面停留时长上报
			try {
				document.addEventListener("visibilitychange", function() {
					if (document.hidden) {
						// 页面隐藏：累加本次可见时间，上报
						that.visibleDuration += Math.round((Date.now() - that.lastVisibleTime) / 1000);
						if (that.info && that.info.formId) that.reportDuration();
					} else {
						// 页面恢复：重置可见起点
						that.lastVisibleTime = Date.now();
					}
				});
				window.addEventListener("beforeunload", function() {
					// 关闭前累加最后一段可见时间
					that.visibleDuration += Math.round((Date.now() - that.lastVisibleTime) / 1000);
					if (that.info && that.info.formId) that.reportDuration();
				});
			} catch (e) { /* ignore */ }

			// 计时器补偿
			document.addEventListener("visibilitychange", function() {
				if (document.hidden === true) {
					that.hideTimeStamp = new Date().getTime();
				}
				if (that.page == 2 && that.totalTime > 0 && that.spandTime > 0 && that.showRecord == 0) {
					if (document.hidden === true) {
						that.hideSpandTime = that.spandTime;
					} else if (that.hideTimeStamp > 0) {
						// 守卫：只有真正经历过 hidden（hideTimeStamp 被设过）才补偿隐藏时长。
						// 否则（如后台标签加载、初始 hidden 未触发 visibilitychange）hideTimeStamp=0，
						// _t 会 =当前 Unix 秒（~17亿），用时变天文数字。
						var _t = Math.round((new Date().getTime() - that.hideTimeStamp) / 1000);
						that.spandTime = that.hideSpandTime + _t;
					}
				}
			});
		},
		methods: {
			getShortId() {
				// let _list = window.location.href.split("/");
				// return _list[_list.length - 1];
				const url = window.location.href;
				const path = url.split('?')[0]; // 取 ? 之前的部分
				const lastSegment = path.split('/').pop(); // 取最后一个路径片段
				return lastSegment?.trim()
			},
			getInfo() {
				let that = this;
				showLoading();
				$.ajax({
					method: "GET",
					url: `${this.host}/timer/h5/info`,
					data: {
						shortId: this.shortId,
						password: this.password,
						ref: new URLSearchParams(window.location.search).get('ref') || '',
						referrer: document.referrer || '',
						pageview_id: this.pageviewId,
					},
					success: function(res) {
						// console.log(res)
						hideLoading();
						if (res.code == 0) {
							that.setInfo(res.data);
						} else {
							that.calert(res.msg);
						}
					}
				})
			},
			setInfo(data) {
				let that = this;

				// urlSwitchOff(是否关闭连接): 0=连接,1=没有连接,
				// passwordOn(是否有密码): 0=无密码,1=有密码,
				// status(时效): 0=未开始,1=正常,2=已结束
				// timerOff(是否无计时): 0=有计时,1=无计时,

				that.info = data;
				
				if (data == null) {
					// 已失效
					// showLoading();
					that.calert("This form link does not exist. Please check the URL and try again.");
					return;
				} else if (data.urlSwitchOff) {
					// 关闭连接
					showLoading();
					that.calert("The link is no longer valid.");
					return;

				} else if (data.passwordOn) {
					// 有密码
					that.page = 0;
					if (data.passwordError) {
						that.calert("Incorrect password. Please try again.");
					}

				} else if (data.timerOff) {
					// 关闭timer
					that.page = 2;
					setTimeout(function() {
						that.addIframeListener();
						that.statistics();
					}, 1000);

				} else {
					// 正常：无密码，有计时
					that.page = 1;

				}

				hideLoading();

				if (data.status == 0) {
					that.page = -1
					that.closedTitle = "Form Not Open Yet";
				} else if (data.status == 2) {
					that.page = -1
					that.description = "This form is now closed and no longer accepting responses.";
				}

				// 跳过开始页：后端已经记录了开始时间，直接进入计时页
				if (data.skipStart && that.page == 1 && data.fingerCode && data.formId) {
					that.autoStart();
				}
			},
			autoStart() {
				let that = this;
				this.totalTime = this.info.time;
				this.page = 2;
				this.statistics();
				this.connectWebSocket();
				this.startTimer();
				setTimeout(function() {
					that.addIframeListener();
				}, 1000);
			},
			// page1
			beforeSubmit() {

				if (this.info.status == 0) {
					
					let message = formatTimestamp(this.info.startStamp)
					this.calert(message, "This form will start accepting responses on");
					return false;

				} else if (this.info.status == 2) {
					
					this.calert("This form is now closed and does not accept any more answers", "Form Closed");
					return false;

				} else if (!this.name) {
					return false;
				}
				return true;
			},
			submit() {
				
				let that = this;
				let _iscan = this.beforeSubmit();
				if (_iscan) {
					showLoading();
					$.ajax({
						method: "POST",
						url: `${this.host}/timer/h5/submit`,
						headers: {
							"Content-Type": "application/x-www-form-urlencoded",
						},
						data: {
							fingerCode: this.info.fingerCode,
							respondent: this.name,
							formId: this.info.formId,
							link_id: this.info.multiLinkId || 0,
						},
						success: function(res) {
							if (res.code == 0) {
								that.totalTime = that.info.time;
								that.page = 2;
								that.statistics();
								that.connectWebSocket();
								setTimeout(function() {
									that.addIframeListener();
								}, 1000);
								setTimeout(function() {
									showLoading();
								}, 100);
								setTimeout(function() {
									hideLoading();
									that.startTimer();
								}, 1000);
							} else {
								that.calert(res.msg);
							}
						},
						complete: function() {
							hideLoading();
						}
					})
				}
			},
			// page2
			startTimer() {
				// console.log("开始计时")
				let that = this;
				if (this.Timer) {
					clearInterval(this.Timer)
					this.Timer = null;
				}
				this.Timer = setInterval(function() {
					that.spandTime += 1;
					that.checkTimeLeftToast(that.totalTime - that.spandTime);
					if (that.spandTime >= that.totalTime) {
						// 超时后不停止计时，继续记录真实用时，直到收到提交确认才停止
						// clearInterval(that.Timer);
						// that.Timer = null;
						// that.playTimeLeftNoice("Time is up");
						// that.calert("Time is up");
					}
				}, 1000)
			},
			stopTimer() {
				//console.log("结束计时");
				clearInterval(this.Timer);
				this.Timer = null;
			},
			showTimeSelect(show) {
				this.timeSelectShow = show
			},
			cover_click() {
				this.timeSelectShow = 0
			},
			toggleTimeLeft(i) {
				if (this.timeLeft_dis[i].time <= this.totalTime - this.spandTime) {
					this.timeLeft_dis[i].isToggle = this.timeLeft_dis[i].isToggle ? false : true;
				}
			},
			checkTimeLeftToast(time) {
				for (var i = this.timeLeft_dis.length - 1; i >= 0; i--) {
					if (this.timeLeft_dis[i].isToggle && !this.timeLeft_dis[i].isMention && this.timeLeft_dis[i].time >=
						time) {
						// console.log(`${this.timeLeft_dis[i].time}秒 提醒`);
						this.playTimeLeftNoice(`${this.getTimeText_type1(this.timeLeft_dis[i].time)} remaining`);
						this.timeLeft_dis[i].isMention = true;
						break;
					}
				}
			},
			addIframeListener() {
				if (this.serverType == 'dev'){
					return
				}
				let that = this;
				if (this.page == 2) {
					document.getElementById("iframe").onload = function() {
						that.successCheckTimer()
					}
				}
			},
			successCheckTimer() {
				let that = this;
				if (this.successTimer != null) {
					clearInterval(this.successTimer);
					this.successTimer = null;
				}
				var num = 0;
				this.successTimer = setInterval(function() {
					//console.log("num: ", num);
					if (num < 3) {
						that.successCheck();
						num++;
					} else {
						clearInterval(that.successTimer);
						that.successTimer = null;
					}
				}, 5000);
			},
			successCheck() {
				//console.log('successCheck')
				let that = this;
				$.ajax({
					method: "POST",
					url: `${this.host}/timer/h5/fingercode/success`,
					headers: {
						"Content-Type": "application/x-www-form-urlencoded",
					},
					data: {
						fingerCode: this.info.fingerCode,
					},
					success: function(res) {
						if (res.code == 0) {
							if (res.data == true) {
								// 检查完成
								clearInterval(that.successTimer);
								that.successTimer = null;
								that.stopTimer();
								that.showRecord = 1;
								that.closeWebSocket();
							}
						}
					},
					complete: function() {}
				})
			},
			reportDuration() {
				try {
					const duration = this.visibleDuration;
					if (duration <= 0 || duration > 86400) return;
					const data = new URLSearchParams();
					data.append('form_id', this.info.formId || '');
					data.append('link_id', this.info.multiLinkId || 0);
					data.append('duration', duration);
					data.append('pageview_id', this.pageviewId);
					if (navigator.sendBeacon) {
						navigator.sendBeacon(`${this.host}/timer/h5/duration`, data);
					} else {
						fetch(`${this.host}/timer/h5/duration`, { method: 'POST', body: data, keepalive: true });
					}
				} catch (e) { /* ignore */ }
			},
			// WebSocket 实时推送（主方案，轮询作为兜底）
			connectWebSocket() {
				if (this.serverType === 'dev' || !this.info.formId || !this.info.fingerCode) return;
				let that = this;
				const channel = this.info.formId + '_' + this.info.fingerCode;
				const wsUrl = 'wss://common-socket.pipiform.com/subscribe/' + channel;

				try {
					this.ws = new WebSocket(wsUrl);
				} catch (e) { return; }

				this.ws.onopen = function() {
					// 心跳：每 30 秒发一次 ping
					that.wsHeartbeat = setInterval(function() {
						try { if (that.ws && that.ws.readyState === WebSocket.OPEN) that.ws.send('ping'); } catch(e) { /* ignore */ }
					}, 30000);
				};

				this.ws.onmessage = function(event) {
					if (event.data === 'pong') return;
					// 收到推送 → 停止计时
					if (that.showRecord === 0) {
						that.stopTimer();
						that.showRecord = 1;
					}
					that.closeWebSocket();
				};

				this.ws.onclose = function() {
					clearInterval(that.wsHeartbeat);
					// 如果还没记录到，3 秒后重连
					if (that.showRecord === 0) {
						setTimeout(function() {
							if (that.showRecord === 0) that.connectWebSocket();
						}, 3000);
					}
				};

				this.ws.onerror = function() { /* ignore */ };
			},
			closeWebSocket() {
				clearInterval(this.wsHeartbeat);
				if (this.ws) {
					try { this.ws.close(); } catch(e) { /* ignore */ }
					this.ws = null;
				}
			},
			getMinuteText(_min) {
                return `${_min} ${_min === 1 ? 'minute' : 'minutes'}`;
            },
            getHourText(_hours) {
              return `${_hours} ${_hours === 1 ? 'hour' : 'hours'}`;
            },
            getDayText(_days) {
              return `${_days} ${_days === 1 ? 'day' : 'days'}`;
            },
			getTimeText_type1(sec) {
				if (!sec || sec <= 0) return '0 seconds';
				if (sec < 60) return `${sec} ${sec === 1 ? 'second' : 'seconds'}`;
                const days = Math.floor(sec / 86400);
                const hours = Math.floor((sec % 86400) / 3600);
                const minutes = Math.floor((sec % 3600) / 60);
                const parts = [];
                if (days > 0) parts.push(this.getDayText(days));
                if (hours > 0) parts.push(this.getHourText(hours));
                if (minutes > 0) parts.push(this.getMinuteText(minutes));
                return parts.join(', ');
			},
			getTimeText_type2(sec) {
				if (!sec) {
					return '0 sec';
				}
				if (sec <= 0) {
					return `0 sec`;
				} else if (sec < 60) {
					return `${sec} sec`
				} else if (sec < 60 * 60) {
					let _min = Math.floor(sec / 60);
					return `${_min} min`;
				} else {
					let _hours = Math.floor(sec / 60 / 60);
					let _min = Math.floor((sec - _hours * 60 * 60) / 60);
					let text = "";
					if (_hours > 0) {
						text += `${_hours} h`;
					}
					if (_hours > 0 && _min > 0) {
						text += " ";
					}
					if (_min > 0) {
						text += `${_min} min`;
					}
					return text;
				}
			},
			getTimeText_type3(sec) {
				if (!sec) {
					return '';
				}
				if (sec <= 0) {
					return `0s`;
				} else if (sec < 60) {
					return `${sec}s`
				} else if (sec < 60 * 60) {
					let _min = Math.floor(sec / 60);
					let _sec = sec - _min * 60;
					let _text = `${_min}m`;
					if (_sec > 0) {
						_text += ` ${_sec}s`;
					}
					return _text;
				} else {
					let _hours = Math.floor(sec / 60 / 60);
					let _min = Math.floor((sec - _hours * 60 * 60) / 60);
					let _sec = sec - _hours * 60 * 60 - _min * 60;
					const parts = [];
					if (_hours > 0) parts.push(`${_hours}h`);
					if (_min > 0) parts.push(`${_min}m`);
					if (_sec > 0) parts.push(`${_sec}s`);
					return parts.join(' ');
				}
			},
			playTimeLeftNoice(text) {
				let that = this;
				const audioPlayer = this.$refs.audioPlayer;
				audioPlayer.play();
				setTimeout(function() {
					that.calert(text);
				}, 100)
			},
			calert(text, title) {
				$("#calert").find(".calert-text").text(`${text}`);
				if (title){
					$("#calert").find(".calert-title").text(`${title}`);
				}
				$("#calert").removeClass('dn');
			},
			hide_calert() {
				$("#calert").addClass('dn');
			},
			statistics() {
				// this.info.statisticsOff = false;
				if (!this.info.statisticsOff) {
					const script = document.createElement('script');
					$(script).attr("data-domain", "formtimers.com/super");
					$(script).attr("defer", "true");
					script.src = 'https://plausible.io/js/script.js';
					script.onload = () => {
						// 文件加载后的回调函数
						//console.log("统计")
					};
					document.head.appendChild(script);
				}
			},
		},
	}

	function showLoading() {
		$("#loading").removeClass("dn");
	}

	function hideLoading() {
		$("#loading").addClass("dn");
	}
</script>

<style scoped>
	@import '../assets/css/common.css';
</style>